export const MIN_PNL = 0.01
